function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.81335 18.9168H14.2531C15.9731 18.9168 17 17.9242 17 16.2127V7.73224C17 6.0122 16.0587 5.01953 14.3386 5.01953H4.81335C3.17032 5.01953 2.06641 6.0122 2.06641 7.73224V16.2127C2.06641 17.9242 3.0933 18.9168 4.81335 18.9168ZM18 14.4926L21.0212 17.1882C21.3121 17.445 21.6544 17.6075 21.9625 17.6075C22.63 17.6075 23.0664 17.1198 23.0664 16.4181V7.51831C23.0664 6.8166 22.63 6.32882 21.9625 6.32882C21.6544 6.32882 21.3121 6.49141 21.0212 6.74814L18 9.43518V14.4926Z",
  fill: "#878793"
});

function SvgIconCameraOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraOn);
export default __webpack_public_path__ + "static/media/icon-camera-on.92c84392.svg";
export { ForwardRef as ReactComponent };